import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../utils/api-helper/api";

import { addSeniorFail, addSeniorSuccess } from "../actions/senior";
import { ADD_SENIOR_REQUEST, AddSeniorRequestAction } from "../types";

import { toast } from "react-toastify";

/**
 * Worker saga for adding a senior.
 * @param action The action containing the senior data.
 */
function* addSeniorSaga(action: AddSeniorRequestAction) {
    try {
        const { senior: seniorData, history } = action.payload;
        // @ts-ignore
        yield call(api.post, "/user/senior/create", seniorData);
        toast.success("Senior added successfully!", {
            position: "top-center",
            hideProgressBar: true,
            theme: "colored",
        });
        yield put(addSeniorSuccess());
        history.push("/admin/users")
    } catch (error: any) {
        toast.error(error?.response?.data?.message || "Registration failed", {
            position: "top-center",
            hideProgressBar: true,
            theme: "colored",
        });
        yield put(addSeniorFail(error));
    }
}

const seniorWatcher = [takeLatest(ADD_SENIOR_REQUEST, addSeniorSaga)];

export default seniorWatcher;
